import { createContext } from "react";
import { ExamConfiguration } from "../hooks/use-exam-config-mapping";

export type AppContextValue = {
  candidateInfo?: any;
  examConfig?: ExamConfiguration;
  isFreezeActive: boolean;
  setCandidateInfo: (candidateInfo: any) => void;
  setExamConfig: (config: ExamConfiguration) => void;
  setIsFreezeActive: (isFreezeActive: boolean) => void;
  refreshFreezeState: () => Promise<boolean>;
  startFreezePolling: () => void;
  stopFreezePolling: () => void;
  clearState: () => void;
};

export const AppContext = createContext<AppContextValue | undefined>(undefined);
